import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

const style = require('./index.css');

export interface ISeoBannerProps {
  context: IAdFoxBannerContext;
}

export const SeoBanner: React.FC<ISeoBannerProps> = props => {
  return (
    <a href={props.context.url} target="_blank" className={style.link} rel="noreferrer">
      <div className={style['bannerContainer']}>
        <div
          className={style['photo']}
          style={{
            backgroundImage: `url(${props.context.bgImageUrl})`,
          }}
        />
        <div className={style['infoContainer']}>
          <div className={style['title']}>{props.context.title}</div>
          <div className={style['description']}>{props.context.description}</div>
          <div className={style['phone']}>{props.context.phone}</div>
        </div>
        <div className={style['note']}>{props.context.note}</div>
      </div>
    </a>
  );
};
